module.exports = __webpack_public_path__ + "static/img/tablet-web-img@m.d7850d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/tablet-web-img@m.png
// module id = G3Aj
// module chunks = 0